import { Controller } from '@hotwired/stimulus';

export default class RequiredFieldsController extends Controller {
  declare private readonly requiredFieldTargets: HTMLElement[];
  declare private readonly submitButtonTargets: HTMLElement[];

  public static targets = ['requiredField', 'submitButton'];

  public connect(): void {
    this.validate();
    this.element.addEventListener('submit', this.validate.bind(this));
  }

  public requiredFieldTargetConnected(requiredFieldTarget: HTMLElement): void {
    requiredFieldTarget.addEventListener('change', this.validate.bind(this));
  }

  public isValid(): boolean {
    return (
      this.requiredFieldTargets.filter(target => {
        const inputElement = target as HTMLInputElement;

        return inputElement.value.trim() === '';
      }).length === 0
    );
  }

  public validate(): void {
    if (this.isValid()) {
      console.log('isValid');
      this.submitButtonTargets.forEach(target => {
        target.removeAttribute('disabled');
      });
    } else {
      console.log('isInvalid');
      this.submitButtonTargets.forEach(target => {
        target.setAttribute('disabled', 'disabled');
      });
    }
  }
}
